import { api } from "./client";

export interface HourBucket {
  bucket: string;
  rfid: number;
  lpr: number;
}

export interface KpiSnapshot {
  serverTime: string;
  activeUnits: number;
  totalUnits: number;
  readingsToday: number;
  hitsToday: number;
  pendingHits: number;
  detectionRatePct: number;
  byHour24h: HourBucket[];
}

export async function getKpis(): Promise<KpiSnapshot> {
  const res = await api.get<KpiSnapshot>("/dashboard/kpis");
  return res.data;
}

// ---------------------------------------------------------------------------
// /dashboard/trends (PR 8)
// ---------------------------------------------------------------------------

export type TrendPeriod = "7d" | "30d" | "90d";

export interface TrendPoint {
  day: string;
  readings: number;
  lprEvents: number;
  hits: number;
  distanciaKm: number;
  anomaliasAbiertas: number;
}

export interface TrendsResponse {
  period: TrendPeriod;
  startDay: string;
  endDay: string;
  points: TrendPoint[];
}

export async function getTrends(
  period: TrendPeriod = "7d"
): Promise<TrendsResponse> {
  const res = await api.get<TrendsResponse>("/dashboard/trends", {
    params: { period },
  });
  return res.data;
}

// ---------------------------------------------------------------------------
// /dashboard/leaderboard (PR 8)
// ---------------------------------------------------------------------------

export type LeaderboardMetric =
  | "hits"
  | "readings"
  | "distancia_km"
  | "anomalias_abiertas"
  | "tiempo_movimiento_seconds";

export interface LeaderboardRow {
  rank: number;
  unitId: number;
  alias: string;
  placa: string | null;
  gerencia: string | null;
  value: number;
}

export interface LeaderboardResponse {
  metric: LeaderboardMetric;
  period: TrendPeriod;
  startDay: string;
  endDay: string;
  rows: LeaderboardRow[];
}

export async function getLeaderboard(params: {
  metric?: LeaderboardMetric;
  period?: TrendPeriod;
  limit?: number;
} = {}): Promise<LeaderboardResponse> {
  const res = await api.get<LeaderboardResponse>("/dashboard/leaderboard", {
    params,
  });
  return res.data;
}
